import React from 'react';

type Props = {
  text: string;
  highlightLength: number;
};

export default function HighlightedWord({ text, highlightLength }: Props) {
  if (highlightLength === 0) {
    return <>{text}</>;
  }
  return (
    <>
      <mark>{text.substring(0, highlightLength)}</mark>
      {text.substring(highlightLength)}
    </>
  );
}
